import React from 'react';
import InputField from './InputField';
import DropDownField from './DropDownField';
import NativeSelect from './NativeSelect';

function FormComponent({ component, ...rest }) {
  switch (component) {
    case 'input':
      return <InputField {...rest} />;
    case 'dropdown':
      return <DropDownField {...rest} />;
    case 'native-select':
      return <NativeSelect {...rest} />;
    default:
      return null;
  }
}

export default FormComponent;
